import React, { useState } from 'react'
import ReactTable from 'react-table'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import {
  Div, H3, Loading, P, DynamicButtonLink,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/tire-patch-shop-components'
import { GET_TIRE_PATCH_SHOP_LIST } from '../../../constants/graphql/query'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'

const { color } = theme


const Index = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รายชื่อร้านปะยาง</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between'>
        <DynamicButtonLink link='/tire-patch-shop/add' condition={_.includes(window.perms, PERMISSION.CREATE_TIREPATCHSTORE)} props={{ text: 'เพิ่มร้านปะยาง' }} />
      </Div>
    </Div>
    <List />
  </Div>
)

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [search, setSearch] = useState({})
  const {
    data, loading, error, refetch,
  } = useQuery(GET_TIRE_PATCH_SHOP_LIST, {
    variables: {
      ...search,
      limit: 5,
      offset: current * 5,
      orderBy: 'ASC',
      orderField: 'id',
    },
  })
  if (loading && _.isEmpty(data)) return <Loading center='true' />
  if (error) return <P>เกิดข้อผิดพลาด</P>
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Div>
        <ReactTable
          className='table'
          data={data.TirePatchStoreList.lists} // *
          resizable={false}
          columns={config.columns} // *
          minRows={5}
          manual
          // defaultPageSize={10}
          showPageSizeOptions={false}
          getTdProps={() => ({ disabled: true })} // *
          getTrProps={(state, rowInfo) => { // *
            if (rowInfo) {
              return {
                style: {
                  padding: '8px 0',
                  backgroundColor: '#ffffff',
                  borderLeft: `3px solid ${color.primaryColor}`,
                },
              }
            } return {}
          }}
          previousText='ก่อนหน้า'
          nextText='ถัดไป'
          pageText='หน้า'
          ofText='จาก'
          page={current}
          pages={Math.ceil(data.TirePatchStoreList.totalFilter / 5)}
          onPageChange={page => setCurrent(page)}
          onFilteredChange={async (newFiltered) => {
            const newObj = {
              name: '',
            }
            await newFiltered.forEach((v) => {
              Object.assign(newObj, { [v.id]: v.value })
            })
            setCurrent(0)
            setSearch(newObj)
          }}
          onSortedChange={async (newSorted) => {
            setCurrent(0)
            refetch({
              orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
              orderField: newSorted[0].id,
            })
          }}
        />
        {
          loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
        }
      </Div>
    </Wrapper>
  )
}
export default Index
